import React from "react";
import "./contact.scss";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, brands } from "@fortawesome/fontawesome-svg-core/import.macro";
import AppFooter from "../../../components/appFooter";

export default function Contact(props) {
  return (
    <div className={"mainDiv"}>
      <div className="brand-bg-inverse-color mb-3 fancyFont">
        <div className="container">
          <nav className="navbar navbar-expand-sm navbar-dark brand-bg-inverse-color">
            <Link to={"/"} className="navbar-brand">
              <img
                src={require("../../../assets/logo.png")}
                alt=""
                width={"140px"}
              />
            </Link>
          </nav>
        </div>
      </div>

      <div className="container fancyFont">
        <div className="row">
          <div className="col-lg-12">
            <h3 className="h3 brand-text-color inner-header">Contact Us</h3>
          </div>

          <div className="col-lg-12">
            <table className="table" width="50%">
              <tbody>
                <tr>
                  <td width="5%">
                    <FontAwesomeIcon icon={solid("envelope-square")} />
                  </td>
                  <td>
                    <Link to={"mailto:info.memonid@gmail.com"} target="_blank">
                      info.memonid@gmail.com
                    </Link>
                    <br />
                    <Link to={"mailto:info@memonid.com"}>info@memonid.com</Link>
                  </td>
                  <td width="5%">
                    <FontAwesomeIcon icon={solid("phone")} />
                  </td>
                  <td>
                    <Link to={"tel:+91 895 673 3564"}>+91 895 673 3564</Link>
                  </td>
                </tr>
                <tr>
                  <td width="5%">
                    <FontAwesomeIcon icon={brands("whatsapp")} />
                  </td>
                  <td>
                    <Link to={"http://wa.me/918956733564"} target="_blank">
                      +91 895 673 3564
                    </Link>
                  </td>
                  <td width="5%">
                    <FontAwesomeIcon icon={solid("globe")} />
                  </td>
                  <td>www.memonid.com</td>
                </tr>
                <tr>
                  <td width="5%">
                    <FontAwesomeIcon icon={solid("map-location-dot")} />
                  </td>
                  <td colSpan="3">
                    Tahirabad Apt., Balamiya Lane, Mahim (w), Mumbai- 400016
                  </td>
                </tr>
                <tr>
                  <td width="5%">
                    <FontAwesomeIcon icon={brands("facebook")} />
                  </td>
                  <td>
                    <a
                      href="https://www.facebook.com/memonID1/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Visit Page
                    </a>
                  </td>
                  <td width="5%">
                    <FontAwesomeIcon icon={brands("youtube")} />
                  </td>
                  <td>
                    <a
                      href="https://www.youtube.com/channel/UCAvomLrLF_xC8RAdVJjynrA"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Visit Channel
                    </a>
                  </td>
                </tr>
                <tr>
                  <td width="5%">
                    <FontAwesomeIcon icon={brands("twitter")} />
                  </td>
                  <td>
                    <a
                      href="https://twitter.com/MemonId"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Visit Twitter
                    </a>
                  </td>
                  <td width="5%">
                    <FontAwesomeIcon icon={brands("instagram")} />
                  </td>
                  <td>
                    <Link
                      to={"https://www.instagram.com/memonid/"}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Visit Instagram
                    </Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <AppFooter />
    </div>
  );
}
